import styled from 'styled-components';
import RCPicker from 'rc-picker';
import { pickerBubbleStyle, pickerInlineStyle } from '../common.styled';

export const TimePickerSC = styled(RCPicker)<{ kind?: 'inline' | 'bubble' }>`
  ${({ kind }) => (kind === 'bubble' ? pickerBubbleStyle : pickerInlineStyle)}
`;
